import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from "@angular/core";
import { FCargosCalculosService } from "../../servicios/f-cargos-calculos.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem } from "primeng/api";
import {  ServiciosCalculosInput,  ServiciosCalculosTotales, ServiciosConsultasInput, ServiciosConsultas, 
  EstadoCuentaInformacion, FCargosCalculos, FCargosCalculosInput, ConsultaLecturas, json_lecturas_cargos } from '../../entidades/entidades';
import { AuthenticationService } from "app/servicios";
import { ActualizaLecturasService } from "../../servicios/actualiza-lecturas.service";

@Component({
  selector: 'app-cargo-detalles-grid',
  templateUrl: './cargo-detalles-grid.component.html',
  styleUrls: ['./cargo-detalles-grid.component.css']
})
export class CargoDetallesGridComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  serviciosCalculosInput: ServiciosCalculosInput;
  serviciosCalculosTotales: ServiciosCalculosTotales;
  serviciosConsultas: ServiciosConsultas[]= [];
  serviciosCalculos: FCargosCalculos[];
  serviciosConsultasInput: ServiciosConsultasInput;
  cuentasSolicitantes: EstadoCuentaInformacion[] = [];//Arreglo que guarda las solicitudes trayendo al componente estado de cuenta
  consultaLecturaFlag: boolean = false;
  itemsMenu: MenuItem[];
  columnasTabla: any[];
  clonedServiciosConsultas: { [s: string]: ServiciosConsultas } = {};
  consultaLecturaRow: ConsultaLecturas[] ;
  consultaLecturas: ConsultaLecturas[] ;
  @Output("cargoDetallesOutput") cargoDetallesOutput: EventEmitter<ConsultaLecturas[]>;
  @Input("esMasivo")   esMasivo: boolean = false;
  public progressBar = false ;
  public eliminadoRegistro = false;


  constructor(
    private fCargosCalculosService: FCargosCalculosService,
    private authenticationService: AuthenticationService,
    private actualizaLecturasService: ActualizaLecturasService
  ) {
    this.cargoDetallesOutput = new EventEmitter();
   }

  async ngOnInit() {
    
    // ===============================================================
    //Opciones del menu
    // ===============================================================
    // prettier-ignore
    this.itemsMenu = [
      { label: "Agregar", icon: "pi pi-plus", command: () => this.add(), },
      { label: "Guardar", icon: "pi pi-save", command: () => this.guardaCargosDetalles(),}
    ];

    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    // prettier-ignore

      this.columnasTabla = [
        { field: "operacion", header: "", ordenar: false, styleHeader: "width: 30px;", },
        { field: "idConcepto", header: "Concepto", ordenar: true, styleHeader: "width: 250px;", },
        { field: "costoUnitario", header: "Precio", ordenar: false, styleHeader: "width: 80px;", },
        { field: "iva", header: "IVA", ordenar: false, styleHeader: "width: 50px;", },
        { field: "monto", header: "Monto", ordenar: false, styleHeader: "width: 80px;", },
      ];
    
    await this.getAllCatConceptos();
   // this.add(); 

  }

  async cambioSelect(consultaLecturaRow: ConsultaLecturas[], cargosDetalles: ConsultaLecturas[], consultaLecturaFlag: boolean) {
    this.consultaLecturaRow = this.consultaLecturas = this.serviciosConsultas = []
    this.consultaLecturaRow = consultaLecturaRow;
    this.consultaLecturas = cargosDetalles;
    this.consultaLecturaFlag = consultaLecturaFlag;
    if(this.consultaLecturaRow ) 
    // si se agregaron cargos ne el front
      if (this.consultaLecturaRow[0]?.cargosJson  && !consultaLecturaFlag)
      {
        this.consultaLecturaRow.forEach(x => {
          const array = JSON.parse(x.cargosJson);
          var auxConta = 1;   
          array.forEach(element => {
            let serviciosConsultasNew = new ServiciosConsultas();
            serviciosConsultasNew.cambio = false;
            serviciosConsultasNew.iva = element.iva;
            serviciosConsultasNew     = element;
            serviciosConsultasNew.id = auxConta;
            serviciosConsultasNew.idConcepto = element.idConcepto;
            serviciosConsultasNew.descripcion =  this.serviciosCalculos.find(x => x.id === parseInt(element.idConcepto))?.label ;
            serviciosConsultasNew.cantidad = 1; 
            serviciosConsultasNew.monto = parseFloat(element.monto);

            this.serviciosConsultas.push(serviciosConsultasNew);
            this.clonedServiciosConsultas[auxConta] = { ...serviciosConsultasNew };
            auxConta ++;
          });
        });
      }
      //si no hay cargos por cargar
      else {
        this.serviciosConsultas = [];
        this.add();
      }
      this.CalculaTotales();
      
  }

  //===============================================================
  //Agrega renglon en el grid
  //===============================================================
  // prettier-ignore
  add() {

    let id = Math.max(...this.serviciosConsultas.map((o) => o.id), 0) + 1;

    let serviciosConsultasNew = new ServiciosConsultas();
    serviciosConsultasNew.cambio = true;
    serviciosConsultasNew.descripcion = 'Seleccione un cargo...';
    serviciosConsultasNew.id = id;
    serviciosConsultasNew.cantidad = 1;
    serviciosConsultasNew.terminoEditar = false;
    this.serviciosConsultas.push(serviciosConsultasNew);
    this.clonedServiciosConsultas[id] = { ...serviciosConsultasNew };
    
  }

  //===============================================================
  //Funciones de la tabla
  //===============================================================
  // prettier-ignore
  onEditInit(event) {
    let cargosConsultasEdit = event.data;
    cargosConsultasEdit.cambio = true;
    cargosConsultasEdit.baja = false;
    cargosConsultasEdit.monto = 0;
    cargosConsultasEdit.iva   = 0;
    cargosConsultasEdit.costo = 0;
    cargosConsultasEdit.cantidad = 1;
    cargosConsultasEdit.terminoEditar = false;
  }

  // prettier-ignore
  onEditCancel(event) {
    let cargosConsultasEdit = event.data;
    cargosConsultasEdit.cantidad = 1;
    let index = this.serviciosConsultas.findIndex(
      (obj) => obj.id === cargosConsultasEdit.id
    );
    
    this.serviciosConsultas[index] = { ...this.clonedServiciosConsultas[cargosConsultasEdit.id] };
  }

  // prettier-ignore
  onDelete(event, index: number) {
    
    event.cambio = false;
    event.baja = true;
    this.cuentasSolicitantes.splice(index,1);
    this.serviciosConsultas = this.serviciosConsultas.filter(val => val.idConcepto !== event.idConcepto);
    this.eliminadoRegistro = true;
    this.CalculaTotales();
  }

  // prettier-ignore
  async onEditComplete(event) {
    try {
      let cargosConsultasEdit = event.data;
      //cargosConsultasEdit.cantidad = 1;

      //numero negativos
      if(cargosConsultasEdit.costo < 0) {
        this.muestraMensaje.error("Ingrese un número mayor a 0.", "top", "center");
        cargosConsultasEdit.costo = 0;
        return;
      }
     
      //Valida si hay cambios
      if (
        cargosConsultasEdit.cantidad === this.clonedServiciosConsultas[cargosConsultasEdit.id].cantidad &&
        cargosConsultasEdit.idConcepto === this.clonedServiciosConsultas[cargosConsultasEdit.id].idConcepto &&
        cargosConsultasEdit.cuentaAgua === this.clonedServiciosConsultas[cargosConsultasEdit.id].cuentaAgua && 
        cargosConsultasEdit.costo === this.clonedServiciosConsultas[cargosConsultasEdit.id].costo
      ) {
        return;
      }

      cargosConsultasEdit.cambio = true;
      cargosConsultasEdit.baja = false;
      cargosConsultasEdit.terminoEditar = true;
      
      let serviciosCalculosSeleccionado = new FCargosCalculos();
      serviciosCalculosSeleccionado = this.serviciosCalculos.filter((x) => x.id == cargosConsultasEdit.idConcepto)[0];

      if (cargosConsultasEdit.idConcepto !== this.clonedServiciosConsultas[cargosConsultasEdit.id].idConcepto) {
        cargosConsultasEdit.descripcion = serviciosCalculosSeleccionado.label;
        cargosConsultasEdit.costo = serviciosCalculosSeleccionado.costo;
        cargosConsultasEdit.cantidad = serviciosCalculosSeleccionado.cantidad;
        cargosConsultasEdit.precio = serviciosCalculosSeleccionado.precio;
        cargosConsultasEdit.iva = serviciosCalculosSeleccionado.iva;
        cargosConsultasEdit.monto = serviciosCalculosSeleccionado.monto;
        this.clonedServiciosConsultas[cargosConsultasEdit.id].idConcepto = serviciosCalculosSeleccionado.id;
      }
      
      //Realiza la consulta del calculo 
      if (cargosConsultasEdit.costo !== this.clonedServiciosConsultas[cargosConsultasEdit.id].costo)
      {
        
        let serviciosCalculosInput = new FCargosCalculosInput();
        serviciosCalculosInput.idConcepto = cargosConsultasEdit.idConcepto;
        serviciosCalculosInput.cantidad = cargosConsultasEdit.cantidad;
        serviciosCalculosInput.costoEditado = cargosConsultasEdit.costo;

        let serviciosCalculosRetornado: FCargosCalculos[];
        serviciosCalculosRetornado    = await this.getCatConceptos(serviciosCalculosInput);

        cargosConsultasEdit.precio = serviciosCalculosRetornado[0].precio;
        cargosConsultasEdit.iva    = serviciosCalculosRetornado[0].iva;
        cargosConsultasEdit.monto  = serviciosCalculosRetornado[0].monto;
        cargosConsultasEdit.costo  = serviciosCalculosRetornado[0].costo;
      }  
      
      this.CalculaTotales();
      
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por onEditComplete");
    }
  }

  CalculaTotales() {
    this.serviciosCalculosTotales = new ServiciosCalculosTotales();
   
    for (var i = 0, len = this.serviciosConsultas.length; i < len; ++i) {
      this.serviciosCalculosTotales.monto = this.serviciosCalculosTotales.monto +this.serviciosConsultas[i].monto;
    }
  }

  // prettier-ignore
  async getAllCatConceptos() {
    try {
      let cargosCalculosInput = new FCargosCalculosInput();
      //operador ternario si se llega a utlizar en otro lado
      this.esMasivo ? cargosCalculosInput.clave = "esMasivo" : null;
      this.serviciosCalculos = null;

      const datoRetorno = await this.fCargosCalculosService.getBusquedas(cargosCalculosInput).toPromise();
      this.serviciosCalculos = datoRetorno;

      let cargosCalculosNew = new FCargosCalculos();
      cargosCalculosNew.label = "Seleccionar...";
      cargosCalculosNew.value = null;
      this.serviciosCalculos.unshift(cargosCalculosNew);
    } catch (e) {
      
       this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por getAllCatConceptos");
    }
  }

  // prettier-ignore
  async getCatConceptos(serviciosCalculosInput) {
    try {
      this.progressBar = true;
      const datoRetorno = await this.fCargosCalculosService.getBusquedas(serviciosCalculosInput).toPromise();
      return datoRetorno;

    } catch (e) {
      
       this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por getCatConceptos");
      this.progressBar = false;
    }
  }

  // prettier-ignore
  async guardaCargosDetalles(){
    try {
      this.progressBar = true;
      let auxFlag = this.serviciosConsultas.some(x => x.terminoEditar);
      if(this.eliminadoRegistro) auxFlag = true;
     if(!auxFlag) 
      { 
        this.muestraMensaje.error("Termine de editar  los registros antes de guardar.", "top", "center");
        return;
      }

      if(!this.consultaLecturaRow.some(x => x.check) && this.consultaLecturaFlag)
      { 
        this.muestraMensaje.error("Seleccione al menos un registro para guardar.", "top", "center");
        return;
      }

      let _json_lecturas_cargos = new json_lecturas_cargos();
      _json_lecturas_cargos.CargosDetalles = JSON.stringify(this.serviciosConsultas);
      _json_lecturas_cargos.id_usuario     = this.authenticationService.currentUserValue.id;
      // Supongamos que la propiedad que deseas de cada objeto en el array se llama "propiedadDeseada"
      let propiedadesDeseadas = this.consultaLecturaRow
      .filter(objeto => objeto.check === true) // Filtrar objetos con propiedad true
      .map(objeto => objeto.id); // Mapear para obtener solo los IDs

      // Luego, puedes convertir ese array de propiedades a JSON usando JSON.stringify()
      _json_lecturas_cargos.ConsultaLecturasId = JSON.stringify(propiedadesDeseadas);

      await this.actualizaLecturasService
        .updateCargos(_json_lecturas_cargos)
        .toPromise();

        this.muestraMensaje.notification("Proceso Concluido", "top", "center");

       //Actualizamos el total
      let auxSUma = 0;
      this.serviciosConsultas.forEach(x => { auxSUma += x.monto; });
      this.consultaLecturaRow.forEach(x => {

        if(x.check)
        {
          x.cargosJson = JSON.stringify(this.serviciosConsultas);
          x.suma = auxSUma;
          x.check = false;  
        }

      });
      this.eliminadoRegistro = false;
      //emitimos
      this.cargoDetallesOutput.emit(this.consultaLecturaRow);
    } catch (e) {
       this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardaCargosDetalles");
      this.progressBar = false;
    }
  }
}